import { useGame } from "../store.js";
import { Multiplier } from "./Multiplier.js";

/**
 * Connected wrapper: subscribes directly to tick-sensitive state so the parent
 * GameView doesn't re-render 30 times a second just to pass these props down.
 */
export function LiveMultiplier({ size = "hero" }: { size?: "hero" | "compact" } = {}) {
  const multiplier = useGame((s) => s.multiplier);
  const cashoutMultiplier = useGame((s) => s.cashoutMultiplier);
  const phase = useGame((s) => s.phase);
  const crackPulseKey = useGame((s) => s.crackPulseKey);

  const value = phase === "win" && cashoutMultiplier ? cashoutMultiplier : multiplier;
  const stateProp =
    phase === "live" ? "live" : phase === "win" ? "win" : phase === "bust" ? "bust" : "idle";

  return <Multiplier value={value} state={stateProp} crackPulseKey={crackPulseKey} size={size} />;
}
